export const environments = [
  'SoftLight', // BLACK - background is false
  'SoftLight', // BRIGHT GREEN BG - background is false 
  'SoftLight',
  'BabbyFace',
  'Clouds',
  'Matrix',
  'Neuron',
  'Water',
  'Sphere',
]